import { Flex, PrimarySecondaryPage } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";

import { ApplicationPageStepper, DocumentUploadSupportingContent } from "../../../components";
import { useDocumentQuery } from "../../../queries/document-uploads/queries";
import { useFundingApplication } from "../../../queries/funding-application/queries";
import { UploadDocumentType } from "../../../types";
import { DocumentNavigationGroup, PoolBancarioDocumentUpload } from "../components";

export const PoolBancarioDocumentUploadPage = () => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: fundingApplicationData } = useFundingApplication(customerDomain);
  const { data: uploadedDocuments } = useDocumentQuery(customerDomain, fundingApplicationData.id);
  const hasUploadedDocuments = !!uploadedDocuments?.filter(
    (doc) => doc.documentType === UploadDocumentType.POOL_BANCARIO
  ).length;

  const PoolBancarioDocumentUploadPrimary = (
    <Flex direction="column" gap="8">
      <PoolBancarioDocumentUpload />
      <DocumentNavigationGroup
        isStepComplete={hasUploadedDocuments || fundingApplicationData.isPoolBancarioSkipped === true}
        forType={UploadDocumentType.POOL_BANCARIO}
      />
    </Flex>
  );

  return (
    <PrimarySecondaryPage
      titleSlot={<ApplicationPageStepper currentStepIndex={1} />}
      showStepperBackground={true}
      title={intl.formatMessage({
        id: "funding-application: upload company Pool Bancario",
        defaultMessage: "Upload your company Pool Bancario",
      })}
      primaryContent={PoolBancarioDocumentUploadPrimary}
      secondaryContent={<DocumentUploadSupportingContent />}
    />
  );
};
